export default __webpack_public_path__ + "89d8a1421ae82fd6ab7797f34749fcea.svg";